module.exports = __webpack_public_path__ + "50cf5f9af4d584a00fe2c3b075f60b57.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gs.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gs.svg
// module chunks = 0